import { render, staticRenderFns } from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=template&id=b386a0a0&scoped=true&"
import script from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=script&lang=js&"
export * from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarToolsPanelSpatialBookmarks.vue?vue&type=style&index=0&id=b386a0a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b386a0a0",
  null
  
)

export default component.exports